export default "__VITE_ASSET__gDUnh31C__"